var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 28,
    viewBox: "0 0 32 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 9.99998H26.5662L20.8575 0.485351C20.5743 0.012716 19.96 -0.141597 19.4854 0.142589C19.0118 0.426776 18.8585 1.041 19.1427 1.51464L24.2338 9.99998H7.76622L12.8574 1.51458C13.1416 1.04093 12.9883 0.426709 12.5147 0.142522C12.0391 -0.141665 11.4268 0.0126487 11.1426 0.485283L5.43389 9.99992H0V11.9999H2.17042L4.71093 25.5517C4.97653 26.9707 6.21676 28 7.66018 28H24.3399C25.7832 28 27.0235 26.9707 27.2881 25.5527L29.8295 11.9999H32.0001C32 11.9999 32 9.99998 32 9.99998ZM25.3222 25.1846C25.2344 25.6572 24.8213 26 24.3398 26H7.66018C7.17873 26 6.76568 25.6573 6.67681 25.1836L4.20463 11.9999H27.7954L25.3222 25.1846Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.9a619b8ed4699338a22d1ecf113b6857.svg";
export { ForwardRef as ReactComponent };